import { render, staticRenderFns } from "./BaseDropzone.vue?vue&type=template&id=7c2ce100&"
import script from "./BaseDropzone.vue?vue&type=script&lang=js&"
export * from "./BaseDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports